<div class="grid">
  <div class="col-12" *ngIf="!cargando">
    <p-panel header="{{ 'SEGMENTOS.LBL_HEADER' | translate}}">
      <div class="grid">
        <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'LBL_CODIGO' | translate }}:</label>
        <label class="lg:col-3 col-6 md:col-8 "><strong>{{segmento.codigo}}</strong></label>
        <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'LBL_NOMBRE' | translate }}:</label>
        <label class="lg:col-3 col-6 md:col-8"><strong>{{segmento.nombre}}</strong></label>
      </div>
      <div class="grid">
        <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'LBL_DESCRIPCION' | translate }}:</label>
        <label class="lg:col-9 col-6 md:col-8 "><strong>{{segmento.descripcion}}</strong></label>
      </div>
      <div class="grid">
        <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'SEGMENTOS.LBL_VALORVENTA' | translate }}:</label>
        <label
          class="lg:col-3 col-6 md:col-8"><strong>{{segmento.indicadorValorVenta ? ('LBL_SI' | translate) : ('LBL_NO' |
          translate)}}</strong></label>

        <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'SEGMENTOS.LBL_HABILITADO' | translate }}:</label>
        <label
          class="lg:col-3 col-6 md:col-8"><strong>{{segmento.indicadorHabilitado ? ('LBL_SI' | translate) : ('LBL_NO' |
          translate)}}</strong></label>
      </div>
      <div class="grid" *ngIf="segmento.indicadorValorVenta">
        <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'SEGMENTOS.LBL_MONTOMINIMO' | translate }}({{ 'LBL_SMLV' | translate }}
          ):</label>
        <label class="lg:col-3 col-6 md:col-8 "><strong>{{segmento.montoMinimo}}</strong></label>
        <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'SEGMENTOS.LBL_MONTOMAXIMO' | translate }}({{ 'LBL_SMLV' | translate }}
          ):</label>
        <label class="lg:col-3 col-6 md:col-8"><strong>{{segmento.montoMaximo}}</strong></label>
      </div>
      <div class="grid">
        <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'SEGMENTOS.LBL_CODIGOSHIVAM' | translate }}:</label>
        <label class="lg:col-3 col-6 md:col-8 "><strong>{{segmento.codigoShivam}}</strong></label>
        <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'SEGMENTOS.LBL_CONTINUARVISITA' | translate }}:</label>
        <label class="lg:col-3 col-6 md:col-8 "><strong>{{segmento.indicadorContinuarVisita ? ('LBL_SI' | translate) : ('LBL_NO' |
          translate)}}</strong></label>
      </div>
      <div class="grid">
        <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'SEGMENTOS.LBL_TIPOOCUPACION' | translate }}:</label>
        <label class="lg:col-9 col-6 md:col-8 "><strong>{{segmento.nombreTipoOcupacion}}</strong></label>
      </div>
      <div class="grid" *ngIf="carImagen || imagen">
        <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'SEGMENTOS.LBL_IMAGEN' | translate }}:</label>
        <div class="lg:col-3 col-6 md:col-8">
          <img alt="" style="width: 100px; max-height: 100px"
               [src]="!carImagen ? imagen : '/assets/images/loader.gif'"/>
        </div>
      </div>
    </p-panel>
    <br>
    <!-- Seccion de ocupaciones -->
    <p-panel header="{{ 'SEGMENTOSOCUPACIONES.LBL_OCUPACIONES' | translate}}">
      <div class="grid">
        <div class="col-12 md:col-12 lg:col-12">
          <p-table [columns]="columnasOcupaciones" [loading]="cargando" #dt
                   [value]="listaSegmentoOcupaciones" selectionMode="single" dataKey="idConstante"
                   [paginator]="true" [rows]="10"  paginatorPosition="bottom">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field"
                    [pSortableColumnDisabled]="!col.sort" class="text-center">
                  {{col.header}}
                  <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr [pSelectableRow]="row">
                <td>{{row.ocupacion}}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="columns.length" class="text-center">
                  {{ 'MSG_NOHAYREGISTROS' | translate}}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </p-panel>
    <br>
    <!-- Seccion de actividades -->
    <p-panel header="{{ 'SEGMENTOSACTIVIDADES.LBL_ACTIVIDADESASIGNADAS' | translate}}">
      <div class="grid">
        <div class="col-12 md:col-12 lg:col-12">
          <p-table [columns]="columnasActividades" [loading]="cargando" #dt
                   [value]="segmentoActividades" selectionMode="single" dataKey="idConstante"
                   [paginator]="true" [rows]="10"  paginatorPosition="bottom">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field"
                    [pSortableColumnDisabled]="!col.sort" class="text-center">
                  {{col.header}}
                  <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr [pSelectableRow]="row">
                <td>{{row.actividad}}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="columns.length" class="text-center">
                  {{ 'MSG_NOHAYREGISTROS' | translate}}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </p-panel>
    <br>
    <!-- Seccion de ingresos -->
    <p-panel header="{{ 'SEGMENTOSOCUPACIONES.LBL_INGRESOS' | translate}}">
      <div class="grid">
        <div class="col-12 md:col-12 lg:col-12">
          <app-segmento-ingresos [segmento]="segmento" [detalle]="true"></app-segmento-ingresos>
        </div>
      </div>
    </p-panel>
    <br>
    <!-- Seccion de endeudamiento -->
    <p-panel header="{{ 'SEGMENTOSOCUPACIONES.LBL_NIVELENDEUDAMIENTO' | translate}}">
      <div class="grid">
        <div class="col-12 md:col-12 lg:col-12">
          <app-segmento-endeudamiento [segmento]="segmento" [detalle]="true" [constanteNIVEND]="constanteNIVEND"></app-segmento-endeudamiento>
        </div>
      </div>
    </p-panel>
    <br>
    <!-- Seccion de activos -->
    <p-panel header="{{ 'SEGMENTOSOCUPACIONES.LBL_ACTIVOS' | translate}}">
      <div class="grid">
        <div class="col-12 md:col-12 lg:col-12">
          <app-segmento-activos [segmento]="segmento" [detalle]="true"></app-segmento-activos>
        </div>
      </div>
    </p-panel>
    <br>
    <!-- Seccion de numero de empleados -->
    <p-panel header="{{ 'SEGMENTOSOCUPACIONES.LBL_EMPLEADOS' | translate}}">
      <div class="grid">
        <div class="col-12 md:col-12 lg:col-12">
          <app-segmento-empleados [segmento]="segmento" [detalle]="true"></app-segmento-empleados>
        </div>
      </div>
    </p-panel>
    <br>
    <!-- Seccion de sector -->
    <p-panel header="{{ 'SEGMENTOSOCUPACIONES.LBL_SECTOR' | translate}}">
      <div class="grid">
        <div class="col-12 md:col-12 lg:col-12">
          <app-segmento-sector [segmento]="segmento" [detalle]="true"></app-segmento-sector>
        </div>
      </div>
    </p-panel>
    <br>
    <!-- Seccion de tipo de contraro -->
    <p-panel header="{{ 'SEGMENTOSOCUPACIONES.LBL_TIPOCONTRATO' | translate}}">
      <div class="grid">
        <div class="col-12 md:col-12 lg:col-12">
          <app-segmento-tipo-contrato [segmento]="segmento" [detalle]="true" [segmentoTemp]="segmentoTemp"></app-segmento-tipo-contrato>
        </div>
      </div>
    </p-panel>
    <br>
    <p-panel header="{{ 'SEGMENTOSPRODUCTOS.LBL_HEADER' | translate}}">
      <div class="grid">
        <div class="col-12 md:col-12 lg:col-12">
          <p-table [columns]="columnasProductos" [loading]="cargando" #dt
                   [value]="segmentoProductos" selectionMode="single" dataKey="idConstante"
                   [paginator]="true" [rows]="10"  paginatorPosition="bottom">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field"
                    [pSortableColumnDisabled]="!col.sort" class="text-center">
                  {{col.header}}
                  <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr [pSelectableRow]="row">
                <td>{{row.producto}}</td>
                <td>{{row.tipoProductoBancario}}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="columns.length" class="text-center">
                  {{ 'MSG_NOHAYREGISTROS' | translate}}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </p-panel>
    <br>
    <p-panel header="{{ 'SEGMENTOTIPOVINCULACION.LBL_TIPOVINCULACION' | translate}}">
      <div class="grid">
        <div class="col-12 md:col-12 lg:col-12">
          <p-table [columns]="colTipoVinculacion"
                   [value]="segTipoVinculacion"
                   [paginator]="true" [rows]="10"  paginatorPosition="bottom">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field"
                    [pSortableColumnDisabled]="!col.sort" class="text-center">
                  {{col.header}}
                  <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr [pSelectableRow]="row">
                <td>{{row.tipoVinculacion}}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="columns.length" class="text-center">
                  {{ 'MSG_NOHAYREGISTROS' | translate}}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </p-panel>
    <div class="grid form-footer-buttons">
      <div class="form-group col-12">
        <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
                pButton (click)="goBack()"></button>
      </div>
    </div>
  </div>
  <div class="col-12 md:col-10 md:col-offset-1 text-center" *ngIf="cargando">
    <i class="fa fa-refresh fa-spin fa-fw"></i>
    <span>{{ 'LBL_CARGANDO' | translate}}...</span>
  </div>
</div>
